import { from, Observable, of } from 'rxjs';
import { ProductService } from "../../shared/services/product.service";
import { Product } from "../../shared/classes/product";
import { IAddBaseItem, IBaseItem, ICartItem, IDeleteBaseItem } from 'src/app/shared/Models/TopCollectionProduct';
import { HomeService } from 'src/app/shared/services/home.service';
import { groupBy, map, mergeMap, tap, toArray } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IUser } from 'src/app/shared/Models/IUser';
import { ToastrService } from 'ngx-toastr';

import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, } from '@angular/core';
import { BuyerService } from 'src/app/shared/services/BuyerService';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { parseWebAPIErrors } from 'src/app/shared/Errors/parseWebAPIErrors';



@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {


  @ViewChild('couponQuery') couponInput: ElementRef<HTMLInputElement>;
  @ViewChild('rewardQuery') rewardInput: ElementRef<HTMLInputElement>;


  public products: Product[] = [];
  cartItems$: Observable<IBaseItem[]>;
  disabledCheckOut = true;
  isRepeatReques = true;

  usedCouponName = '';
  isCouponApplied = false;
  isRewardApplied = false;
  isDiscountApplied = false;
  rewardAmount = 0;
  couponDisabled = false;
  rewardDisabled = false;
  discountDisabled = false;
  totalPrice = 0;
  totalPriceAfterDiscount = 0;
  totalPurchases =0;

  orderForm: FormGroup;
  ordertItemForm: FormGroup;

  

  constructor(public productService: ProductService,
    private _router: Router,
    private _toastrService: ToastrService,
    private _buyerService: BuyerService,
    private _formBuilder: FormBuilder,
    private _homeService: HomeService) 
    {
    this.productService.cartItems.subscribe(response => this.products = response);
    }

  ngOnInit(): void {

    this.cartItems$ = this._homeService.getCartItems$;

    this.cartItems$.subscribe((items:IBaseItem[])=>{

      if(this.isRepeatReques)
      {
        if(!items || items.length==0)
        {
          this._homeService.baseItems("CartItem").subscribe((cartItems:IBaseItem[])=>{
            this.getTotalPrice(cartItems);
            // this.totalPrice = cartItems.reduce((sum, current) => sum + current.quantitiesInCartItem * current.unitPrice,0);

          });

          this.isRepeatReques = false;
          return;
        }
      }


      if(items != undefined && items !=null)
      {
        // this.totalPrice = ittems.reduce((sum, current) => sum + current.quantitiesInCartItem * current.unitPrice,0);
        this.getTotalPrice(items);

        this.disabledCheckOut = items.some(x=>x.quantitiesInCartItem>x.stock);

      }

      let user: IUser = JSON.parse(localStorage.getItem('user'));
      if(!user)
      {
        this._router.navigateByUrl('/pages/login')
        this.disabledCheckOut = false;
      }

      

      this.orderForm = this._formBuilder.group({
        buyerName: [''],
        couponName: [''],
        buyerId: [user.id?user.id:'', [Validators.required]],
        orderNote: [''],
        discount: [0],
        reward: [0],
    });


    const decimalRegex = '^[+-]?(([1-9][0-9]*)?[0-9](.[0-9]*)?|.[0-9]+)$';
    // Create the form
    this.ordertItemForm = this._formBuilder.group({
        orderItemId: [0],
        barcode: [null, Validators.required],
        productName: [''],
        quantity: [
            1,
            [
                Validators.required,
                Validators.min(0),
                Validators.max(100000),
                Validators.pattern(decimalRegex),
            ],
        ],
        unitPrice: [
            0,
            [
                Validators.required,
                Validators.min(0),
                Validators.max(100000),
                Validators.pattern(decimalRegex),
            ],
        ],
        purchasePrice: [
            0,
            [
                Validators.required,
                Validators.min(0),
                Validators.max(100000),
                Validators.pattern(decimalRegex),
            ],
        ],
    });




    })




  }

  getTotalPrice(cartItems:IBaseItem[])
  {
    this.totalPrice =0;

     this.totalPrice = cartItems.reduce((prev, curr: IBaseItem) => {
     
      let price = curr.wholeSalePrice>0
                    ?curr.wholeSalePrice:curr.newPrice>0
                    ?curr.newPrice:curr.unitPrice;
      return prev + price * curr.quantitiesInCartItem;
    }, 0);

  }


  // public get getTotal(): Observable<number> {
  //   return this._homeService.cartTotalAmount();
  //   // return this.productService.cartTotalAmount();
  // }

  // Increament
  increment(product, qty = 1) {

  var isPass =  this._homeService.calculateStockCounts(product,qty);
    if(!isPass)
    {
      return
    }

    var user:IUser = JSON.parse(localStorage.getItem('user'));
    if(!user)
    {
      this._toastrService.info("User no login");
      return;
    }


    let cartItem: IAddBaseItem = {
      barcode: product.barcode,
      quantitiesInCartItem: qty,
      tableName:"CartItem"

    }

    this._homeService.addBaseItem(cartItem).subscribe({
      next:()=>{
        
        this._router.navigate(['/shop/cart']); 
        // if(user.isWholeSaleAccount.toString()==="True")
        // {
        //   location.reload();
        // }
        location.reload();

      },
      error:()=>{},
      complete:()=>{console.log('completed')}
    }); 

   // this._homeService.updateCartQuantity(product, qty);
  //  this.productService.updateCartQuantity(product, qty);
  }

  // Decrement
  decrement(product, qty = -1) {


    var isPass =  this._homeService.calculateStockCounts(product,qty);
    if(!isPass)
    {
      return
    }


    var user:IUser = JSON.parse(localStorage.getItem('user'));
    if(!user)
    {
      this._toastrService.info("User no login");
      return;
    }


    let cartItem: IAddBaseItem = {
      barcode: product.barcode,
      quantitiesInCartItem: qty,
      tableName:"CartItem"

    }

    this._homeService.addBaseItem(cartItem).subscribe({
      next:()=>{
            

        // if(user.isWholeSaleAccount.toString()==="True")
        // {
        //   location.reload();
        // }
        location.reload();

        // this._router.navigate(['/shop/cart']);
      
        
      },
      error:()=>{},
      complete:()=>{console.log('completed')}
    }); 

  }

  public removeItem(product: IBaseItem) {

    var user:IUser = JSON.parse(localStorage.getItem('user'));
    if(!user)
    {
      this._toastrService.info("User no login");
      return;
    }

    var productToDelete:IDeleteBaseItem ={
      barcode: product.barcode,
      tableName: product.tableName
    }

    this._homeService.removeCartItem(productToDelete).subscribe({
      next:()=>{

        location.reload();

      }
    });

    //this.productService.removeCartItem(product);
  }
   
  onSelectedReward(event) {
    if (event) {
        this.isRewardApplied = true;
    } else {
        this.isRewardApplied = false;
    }
  }

  applyCoupon(couponName: string) {
    if (!couponName) {
        return;
    }

    if (this.usedCouponName === couponName) {
        this._toastrService.info(`You already applied this coupon.`);
        return;
    }

    
  }

  onCouponBlur(value: string) {
    if (!value) {
        var couponInputValue = this.couponInput.nativeElement.value;
        if (couponInputValue.length <= 0) {
            this.isCouponApplied = false;
            this.disabled();

            this.usedCouponName = '';
            this.totalPriceAfterDiscount = 0;
        }
    }
  }





  applyReward(rewardValue: number) {
      if (rewardValue <= 0) {
          return;
      }

      if (rewardValue != 10) {
          this._toastrService.info(
              'You can just use $10 and total Item must be bigger than $10.'
          );
          return;
      }

      var buyer:IUser = JSON.parse(localStorage.getItem('user'));

      if(!buyer)
      {
        this._toastrService.info(
          'You are not login'
      );
      return;
      }


      this._buyerService.accountReward(buyer.id).subscribe({
          next: (rewadAmount) => {
              if (this.isRewardApplied) {
                  this._toastrService.info(`you are already reward applied.`);
                  return;
              }

              if (rewadAmount < 10) {
                  this._toastrService.info('.');
                  return;
              }

              if (rewadAmount < 10) {
                  this._toastrService.info(
                      'Rward amount must be bigger than $10.'
                  );
                  return;
              }

              if (rewardValue > 10) {
                  this._toastrService.info(
                      'You must use $10 for each check out.'
                  );
                  return;
              }

              if (rewardValue > rewadAmount) {
                  this._toastrService.warning(
                      'you are using more than amount of the user reward amount'
                  );
                  return;
              }

              if (rewardValue > this.totalPurchases) {
                  this._toastrService.info(
                      'Not applied, because applied reward is begger than total order price.'
                  );
                  return;
              }

              this.isCouponApplied = false;
              this.isRewardApplied = true;
              this.isDiscountApplied = false;
              this.disabled();

              this.couponInput.nativeElement.value = '';

              this.orderForm.get('reward').setValue(rewardValue);
              this._toastrService.success(
                  `Successfully  $${rewardValue} of reward applied.`
              );
              this.totalPriceAfterDiscount =
              this.totalPurchases - rewardValue;
          },
          error: (error) => {
              parseWebAPIErrors(error).forEach((e: any) => {
                  this._toastrService.warning(e);
              });
          },
      });
  }

    onRewardBlur(value: any) {
      if (!value) {
          this.isRewardApplied = false;
          this.disabled();
          this.orderForm.get('reward').setValue(0);
          this.rewardInput.nativeElement.value = '';
          this.totalPriceAfterDiscount = 0;
      }
      if (value) {
          if (value <= 0) {
              this.isRewardApplied = false;
              this.disabled();
              this.orderForm.get('reward').setValue(0);
              this.rewardInput.nativeElement.value = '';
              this.totalPriceAfterDiscount = 0;
          }
      }
  }

colorCouponApplied() {
    return this.isCouponApplied ? 'green' : '';
}

colorRewardApplied() {
    return this.isRewardApplied ? 'green' : '';
}

colorDiscountApplied() {
    return this.isDiscountApplied ? 'green' : '';
}

disabled() {
    if (this.isCouponApplied) {
        this.couponDisabled = !this.isCouponApplied;
        this.rewardDisabled = this.isCouponApplied;
        this.discountDisabled = this.isCouponApplied;
    }

    if (this.isRewardApplied) {
        this.couponDisabled = this.isRewardApplied;
        this.rewardDisabled = !this.isRewardApplied;
        this.discountDisabled = this.isRewardApplied;
    }

    if (this.isDiscountApplied) {
        this.couponDisabled = this.isDiscountApplied;
        this.rewardDisabled = this.isDiscountApplied;
        this.discountDisabled = !this.isDiscountApplied;
    }

    if (
        !this.isCouponApplied &&
        !this.isRewardApplied &&
        !this.isDiscountApplied
    ) {
        this.couponDisabled = false;
        this.rewardDisabled = false;
        this.discountDisabled = false;
    }
}





}
